export const CommentsOn = {
  Routine: 'routine',
  ActivityExplore: 'activityExplore',
  Webinar: 'webinar',
  Podcast: 'podcast',
  InstagramReel: 'instagramReel',
  Symptom: 'symptom',
  WebinarSuggestion: 'webinarSuggestion',
} as const

export type CommentsOn = (typeof CommentsOn)[keyof typeof CommentsOn]
